import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { getDppContent } from 'Api/DppApi';
import { getPlans } from 'State/Plans/PlansActions';
import { fetchSubscriptions } from 'State/Subscriptions/SubscriptionsActions';
import { fetchPayments } from 'State/Payments/PaymentActions';
import { CancelButton } from 'Components/Fields/Buttons';
import { RedfastZone } from 'Components/RedfastZone';

import './CancelPlanContainer.css';

export const CancelPlanContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dppChecked, setDppChecked] = useState(false);
  const [cancelPreview, setCancelPreview] = useState('');
  const { defaultConfig, routes, screens } = useSelector((s) => s.appConfig);
  const { getPlansSuccess } = useSelector((s) => s.plans);
  const { isSuccess, activeSubscriptionId, hasActiveSubscription } = useSelector((s) => s.subscription);
  const { cancelPlanPreview } = screens;
  const { entitlementId } = defaultConfig;

  useEffect(() => {
    getDppContent(cancelPlanPreview).then((member) => {
      if (member && member.length > 0) {
        const [previewPanel = {}] = member;
        const { headline = '' } = previewPanel;
        setCancelPreview(headline);
        setDppChecked(true);
      }
    });
  }, [cancelPlanPreview]);

  useEffect(() => {
    if (!isSuccess) {
      dispatch(fetchSubscriptions());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    dispatch(fetchPayments(entitlementId));
  }, [dispatch, entitlementId]);

  useEffect(() => {
    if (!getPlansSuccess && activeSubscriptionId) {
      dispatch(getPlans());
    }
  }, [getPlansSuccess, activeSubscriptionId, dispatch]);

  const isLoading = useMemo(() => getPlansSuccess && dppChecked, [getPlansSuccess, dppChecked]);

  const onCancel = async () => {
    return navigate(routes.cancelSurvey);
  };

  if (!hasActiveSubscription) {
    return <Navigate replace to={routes.myAccount} />;
  }

  return (
    <CenterFrameLayout title={cancelPreview || "We're sad to see you go"} showLoader={!isLoading}>
      <div className="centerFormWide">
        <RedfastZone name="CancelInterruptZone" />
        <CancelButton text="Cancel my subscription" onClick={() => onCancel('Cancel my subscription')} />
      </div>
    </CenterFrameLayout>
  );
};
